<template>
  <div
    class="page--lipstickbar home"
    :style="`background-color:#FFCAD8;background-image:url(${lipstickbarBg});background-size:cover;`"
  >
    <div class="container-lipstickbar">
      <img src="/static/img/lipstickbar/logo.png" class="logo" />

      <h2 class="heading">Lipstick Bar</h2>
      <p class="copywriting">Find your most favorite lipstick here</p>

      <router-link to="/lipstickbar/brands" class="btn btn-dark btn-explore">EXPLORE NOW</router-link>
    </div>

    <div class="box">
      <div class="box__paraf">Aplikasi mobile <span class="bolder">SOCO</span> tersedia di iOS dan Android</div>
      <div class="group-btn text-center">
        <a href="" class="btn btn-dark btn-download btn-download--appstore"></a>
        <a href="" class="btn btn-dark btn-download btn-download--playstore"></a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
const Config = require('~/config/default.env').default;

export default {
  name: 'LipstickbarHome',
  data() {
    return {
      lipstickbarBg: '',
    };
  },
  created() {
    this.$store.dispatch('saveStoreIdCookies', this.$route.query.store_location_id);
    this.setLipstickbarBg();
  },
  methods: {
    setLipstickbarBg() {
      //Commented this line, to prevent too many redirect if hit this endpoint
      // delete axios.defaults.withCredentials;
      axios
        .get(`${Config.MS_SOCO_PUBLIC_API_URL}/offline-store/store-cms/cover?type=cover`)
        .then((response) => {
          if (response.status === 200) {
            const data = response.data.data;
            for (const i in data) {
              if (data[i].available_screen == 'Lipstick Bar' && data[i].image_1) {
                this.lipstickbarBg = data[i].image_1;
              }
            }
            axios.defaults.withCredentials = true;
          }
        })
        .catch((error) => {
          // console.log(error)
        });
    },
  },
};
</script>
